<template>
<div>
  <div class="content">
    <van-form ref="formRef" @submit="submitJsy">
      <van-cell-group inset class="formContent">
        <div class="upload-jsz-front">
          <h2 class="jsz-titile input-title-hq red-required">从业资格证正面</h2>
          <van-field name="congyezigeurl" :required="true"
                     :rules="[{ required: true, message: '请上传从业资格证正面' }]">
            <template #input>
              <div class="upload-cyzgz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_image" :before-read="beforeRead" :after-read="uploadCyzgzFront" :before-delete="deleteCyzgzFront"></van-uploader>
              </div>
            </template>
          </van-field>

          <h2 class="jsz-titile input-title-hq">从业资格证反面</h2>
          <van-field name="congyezigefmurl" :required="true"
                     :rules="[{ required: true, message: '请上传从业资格证反面' }]">
            <template #input>
              <div class="upload-cyzgz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_fm_image" :before-read="beforeRead" :after-read="uploadCyzgzFm" :before-delete="deleteCyzgzFm"></van-uploader>
              </div>
            </template>
          </van-field>
        </div>

        <div class="upload-cyzgz-front">
          <div class="jsz-front-info-box">
            <van-field v-model="ysy_name" name="ysy_name" required :value="ysy_name" :rules="[{ validator:validatorYsyName, message: '请填写姓名' }]" placeholder="请输入" @input="refreshDriver">
              <template #label>
                <span class="input-left-label-hq">姓名</span>
              </template>
            </van-field>
            <van-field v-model="shenfenzheng" name="shenfenzheng" required :value="shenfenzheng" :rules="[{ validator:validatorYsyNo, message: '请填写身份证号' }]" placeholder="请输入" @input="refreshDriver">
              <template #label>
                <span class="input-left-label-hq">身份证号</span>
              </template>
            </van-field>
            <van-field v-model="telephone" name="telephone" type="tel" required :value="telephone" :rules="[{ validator:validatorYsyTel, message: '请填写联系电话' }]" placeholder="请输入" @input="refreshDriver">
              <template #label>
                <span class="input-left-label-hq">联系电话</span>
              </template>
            </van-field>
          </div>

          <div class="jsz-cyzgz-info-box">
            <ChoseTime :timeVmodel="cyzgYxq" :timeName="cyzgYxq" :timeLabel="cyzgYxqLabel" @getYxq="getCyzgYxq" :timeValue="cyzgz_yx_time" />
          </div>
        </div>
      </van-cell-group>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#316892">
          保存
        </van-button>
      </div>

    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Toast,
  Dialog
} from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
import autoSubmitBeian from '@/mixins/autoSubmitBeian';
import store from '@/store';
export default {
  components: {
    ChoseTime,
    Tabbar,
  },
  mixins: [autoSubmitBeian],
  data() {
    return {
      jsz_zm: '',
      cyzgz_zm: '',
      cyzgz_image: [],
      cyzgz_fm_image: [],
      ysy_name: "",
      shenfenzheng: "",
      telephone: "",
      loadingBtn: false,
      cyzgz_url: "",
      cyzgz_fm_url: "",
      cyzgz_yx_time: "",
      cyzgYxq: "cyzgz_yx_time",
      cyzgYxqLabel: "从业资格证截至日期",
      // 动态引导步骤
      steps: []
    };
  },
  created() {
    document.title = "添加押送员信息";
    // 初始化引导步骤
    const step = [
      {
        element: '.upload-jsz-front',
        popover: {
          title: '请上传对应证件',
          showButtons: ['next'],
          // 下一步
          onNextClick: () => {
            this.$refs.formRef.validate(['congyezigeurl', 'congyezigefmurl']).then(() => {
              this.$driverObj.moveNext();
            }).catch(() => {
              this.$driverObj.refresh();
            })
          },
        }
      },{
        element: '.jsz-front-info-box',
        popover: {
          title: '请确认信息是否在正确',
          showButtons: ['previous','next'],
          // 下一步
          onNextClick: () => {
            this.$refs.formRef.validate(['ysy_name', 'shenfenzheng','telephone']).then(() => {
              this.$driverObj.moveNext();
            }).catch(() => {
              this.$driverObj.refresh();
            })
          },
        }
      },{
        element: '.addBtn',
        popover: {
          title: '点击保存',
          description: '提交押运员信息',
          showButtons: ['previous'],
        }
      }
    ]
    this.$driverObj.setSteps(step);
  },
  mounted() {
    // 开始引导
    store.state.isFirstTime && this.$driverObj.drive();
  },
  destroyed() {
    this.destroyDriver()
  },
  methods: {
    // 销毁引导
    destroyDriver() {
      store.state.isFirstTime && this.$driverObj.destroy()
    },
    // 刷新引导
    refreshDriver() {
      store.state.isFirstTime && this.$driverObj.refresh()
    },
    // 继续引导
    continueDriver(step) {
      store.state.isFirstTime && this.$driverObj.drive(step);
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    validatorYsyName(val) {
      if (!val) {
        Toast.fail('请填写姓名');
        return false;
      }
      return val;
    },
    validatorYsyNo(val) {
      if (!val) {
        Toast.fail('请填写身份证号');
        return false;
      }
      return val;
    },
    validatorYsyTel(val) {
      if (!val) {
        Toast.fail('请填写联系电话');
        return false;
      }
      return val;
    },
    isCardNo(card) {
      //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{17}(\d|X|x)$)/;
      if (reg.test(card) === false) {
        return false;
      }
      return true;
    },
    //提交表单
    submitJsy(values) {
      this.destroyDriver()
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var congyezigeurl = that.$data.cyzgz_url;
      var congyezigefmurl = that.$data.cyzgz_fm_url;
      if (!congyezigeurl) {
        Toast.fail('请上传从业资格证');
        return false;
      }

      var shenfenzheng = values.shenfenzheng ? values.shenfenzheng : "";
      if (!this.isCardNo(shenfenzheng)) {
        Toast.fail('身份证号码格式不正确');
        return false;
      }

      that.$data.loadingBtn = true;
      var formData = JSON.stringify({
        congyezigeurl: congyezigeurl,
        congyezigefmurl: congyezigefmurl,
        congyezigeyxq: that.$data.cyzgz_yx_time ? that.$data.cyzgz_yx_time : "",
        name: values.ysy_name ? values.ysy_name : "",
        openid: openid,
        shenfenzheng: shenfenzheng,
        telphone: values.telephone ? values.telephone : "",
      });

      api.beianYsy(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var newId = '';
          if (resData.data) {
            if (resData.data.id) {
              newId = resData.data.id;
            } else if (typeof resData.data === 'string' || typeof resData.data === 'number') {
              newId = resData.data;
            }
          }
          if (newId) {
            that.autoSubmitBeian('escort', newId, 'escortList');
          } else {
            Dialog.alert({
              message: '信息保存成功',
            }).then(() => {
              that.$router.push({
                name: 'escortList'
              })
            });
          }
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    getCyzgYxq(xszYxq) {
      this.continueDriver(1)
      this.cyzgz_yx_time = xszYxq
    },

    //上传从业资格证
    uploadCyzgzFront(file) {
      this.refreshDriver();
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData.congyezigeurl
          }];
          that.cyzgz_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          if(that.ysy_name != imageData.name && that.ysy_name)
          {
            Toast.fail("证件姓名与登记姓名不符合");
          }
          else if(!that.ysy_name && imageData.name){
            that.ysy_name = imageData.name;
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        }
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadCyzgzFm(file) {
      this.refreshDriver();
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_fm_image = [{
            url: weburl + '/' + imageData.congyezigeurl
          }];
          that.cyzgz_fm_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          if(that.ysy_name != imageData.name && that.ysy_name)
          {
            Toast.fail("证件姓名与登记姓名不符合");
          }
          else if(!that.ysy_name && imageData.name){
            that.ysy_name = imageData.name;
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        }
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteCyzgzFront() {
      this.$data.cyzgz_image = [];
      this.$data.cyzgz_url = "";
    },
    deleteCyzgzFm() {
      this.$data.cyzgz_fm_image = [];
      this.$data.cyzgz_fm_url = "";
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}
.upload-jsz-front {
    //border-top: 1px solid #ececec;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
    }
    .upload-cyzgz-front-box {
        margin-left: 1rem;
    }
}
</style>
